export default __webpack_public_path__ + "static/media/misc-closetB-480w.23a8a088.png";